import { AxiosError } from "axios";

export type ApiErrorBody = { error?: string; message?: string; code?: string };

export function extractError(err: unknown): string {
  if (err instanceof AxiosError) {
    const body = err.response?.data as ApiErrorBody | undefined;
    return body?.error ?? body?.message ?? err.message;
  }
  return "An unexpected error occurred";
}
